<template lang="html">
<div fill-height>
    <!-- top parralax for features -->
    <v-parallax dark height=150 src="img/parallax/blue.jpg">
      <v-row align='center' justify='center'>
        <v-col class="text-center" cols="12">
          <h1 class="display-4 font-weight-thick hidden-sm-and-down">Production Toolkit</h1>
          <h1 class="display-3 font-weight-thick hidden-md-and-up">Production Toolkit</h1>
        </v-col>
      </v-row>
    </v-parallax>

    <!-- start of scheduling section -->
    <v-row justify="center" align='center'>
      <v-col class="text-center"
            :md='10'
            :sm='12'
            >
        <!-- <v-container class="grey lighten-5"> -->
          <v-row class="fill-height"
                 align="center"
                 justify="center">
                 <v-col
                 :md='6'
                 :xs='10'
                 order-md='2'>
                 <div class='display-2 orange--text pb-5 hidden-md-and-up'>Leaderboard</div>
                   <v-img class='contain' src='img/leaderboard.png' />
                 </v-col>
            <v-col class='title'
                    order-md='1'
                    :md='6'
                    :xs='12'>
              <div class='display-2 orange--text pb-5 hidden-sm-and-down'>Leaderboard</div>
              <blockquote class="blockquote text-left">
                Ready for technicians to raise the level of their performance? Leaderboard actively tracks your technican and production departments production and efficiency,
                updating live through the power of movement in Production Board. View all assignees, set goals and track live performance. Creates inter-departmental goals and
                sets expectations of your technicions, while holding them accountable real-time.
              </blockquote>
              <v-btn class='btn success' target='_blank' href="https://calendly.com/productionboard/production-board-demo?back=1&month=2022-10">Schedule Demo</v-btn>
            </v-col>
          </v-row>
        <!-- </v-container> -->
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col
      :md='10'
      :sm='12'
      >
        <!-- Start of scheduling cards -->
        <v-row justify="center" align="center">
          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'
          >
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     height="200px"
                     src="img/card/detailflag.png">
                <v-card-title></v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 subtitle-2 orange--text text--darken-2">Assignee Flagged Hours</v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  Track flagged hours by assignees and departments creating your shops leaders. Print a flagged labor report that provides
                  a deatiled job flagged hours view.
                </div>
              </v-card-text>

            </v-card>
          </v-col>

          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'
          >
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     cover
                     height="200px"
                     src="img\card\efficiency.png">
                <v-card-title></v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 subtitle-2 orange--text text--darken-2">Assignee & Department Efficiency</v-card-subtitle>
              <v-card-text class="text--primary">
                <div>
                  Real time cycle times, captured through the power of movement, drive your Assignee and Department efficiency scores raising production awareness.
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'
          >
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     height="200px"
                     cover
                     src="img/card/basketball.jpeg">
              </v-img>
              <v-card-subtitle class="pb-0 subtitle-2 orange--text text--darken-2">Create Accountability</v-card-subtitle>
              <v-card-text class="text--primary">
                <div>Live production stats drive your team towards new heights as leaderboard "keep score" of the game creating a friendly competition among Assignees.</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'
          >
            <v-card class="mx-auto">
              <v-img
                  cover
                  class="white--text align-end"
                  height="200px"
                  src="img/gif/hoursefic.gif">
              </v-img>
              <v-card-subtitle class="pb-0 subtitle-2 orange--text text--darken-2">Department Flagged Hours and Efficiency</v-card-subtitle>
              <v-card-text class="text--primary">
                <div>Actively track department hours produced and identify opportunities for improvement. Department efficiency gives powerful insight into department performance.</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- end of scheduling cards -->
      </v-col>
    </v-row>

    <!-- END of scheduling section -->

    <v-parallax src="img/ads/darkleaderboard.png"></v-parallax>


    <v-row justify="center">
      <v-col class="text-center"
            :md='10'
            :sm='12'>
          <v-row class="fill-height"
                 align="center"
                 justify="center">
           <v-col
           :md='6'
           :sm='10'
           order-md='2'>
             <div class='display-2 green--text text--darken-2 hidden-md-and-up'>Terminal</div>
             <v-img class='contain' src='img/terminal.png' />
           </v-col>
            <v-col
            class='title'
            order-md='1'
            :md='6'
            :sm='12'
            >
              <div class='display-2 green--text text--darken-2 hidden-sm-and-down'>Terminal</div>
              <blockquote class="blockquote text-left">
                Terminal quickly informs you to production critical data with jobs scheduled to arrive and depart for the selected day.
                Visual indicators alert you to the arrival and departure status of each job with additional production critical data.
              </blockquote>
              <v-btn class='btn success' target='_blank' href="https://calendly.com/productionboard/production-board-demo?back=1&month=2022-10">Schedule Demo</v-btn>
            </v-col>

          </v-row>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col
      :md='10'
      :sm='11'
      >
        <!-- Start of workflow cards -->
        <v-row justify="center" align="center">
          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'>
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     height="200px"
                     src="img/card/visual.png">
                <v-card-title></v-card-title>
              </v-img>

              <v-card-subtitle class="pb-0 subtitle-2 green--text text--darken-2">Visual Production Alerts</v-card-subtitle>

              <v-card-text class="text--primary">
                <div>Visual indicators inform the user of production critical data from simple arrival and departures, department status and much more!</div>
              </v-card-text>

            </v-card>
          </v-col>



          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'>
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     height="200px"
                     src="img/parallax/pboardss.png">

              </v-img>

              <v-card-subtitle class="pb-0 subtitle-2 green--text text--darken-2">Arrival Summary & Detail</v-card-subtitle>

              <v-card-text class="text--primary">
                <div>Daily Arrival KPI's provide insight into job count hours to create a consistent workflow into production each day.</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'>
            <v-card class="mx-auto fill-height">
              <v-img
                cover
                class="white--text align-end"
                height="200px"
                src="img\ads\terminal.png">
              </v-img>

              <v-card-subtitle class="pb-0 subtitle-2 green--text text--darken-2">Departure Summary & Detail</v-card-subtitle>

              <v-card-text class="text--primary">

                <div>
                  Daily Departure KPI keep you informed in summary and detail for the count and hours identifying trends and areas of opportunity.
                </div>
              </v-card-text>

            </v-card>
          </v-col>
          <v-col align="center"
          :lg='3'
          :md='4'
          :sm='10'>
            <v-card class="mx-auto fill-height">
              <v-img class="white--text align-end"
                     height="200px"
                     src="img/gif/pbworkflow.gif">
              </v-img>

              <v-card-subtitle class="pb-0 subtitle-2 green--text text--darken-2">Power Of Movement</v-card-subtitle>

              <v-card-text class="text--primary">

                <div>Terminal automatically updates as your staff updates the job by moving the job tiles. No Reports to run just the results of your production</div>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
        <!-- end of workflow cards -->
      </v-col>
    </v-row>
</div>


</template>

<script>

  export default {
    data() {
      return {
        card_text:
          'Lorem ipsum dolor sit amet, brute iriure accusata ne mea. Eos suavitate referrentur ad, te duo agam libris qualisque, utroque quaestio accommodare no qui. Et percipit laboramus usu, no invidunt verterem nominati mel. Dolorem ancillae an mei, ut putant invenire splendide mel, ea nec propriae adipisci. Ignota salutandi accusamus in sed, et per malis fuisset, qui id ludus appareat.'
      }
    }
  }

</script>
